import API from "../utilities/axiosConfig";
import { OperationResult, CommentDto, CommentListResponse, CreateCommentDto, CommentLikeStatus } from "../types/comment";

export const getComments = async (
  photoId: number,
  page: number = 1,
  pageSize: number = 3
): Promise<CommentListResponse> => {
  try {
    const response = await API.get(`/api/comments`, {
      params: { photoId, page, pageSize },
    });
    return response.data;
  } catch (error: any) {
    console.error("Failed to load comments:", error);
    throw error.response?.data || new Error("An unexpected error occurred while loading comments.");
  }
};

export const addComment = async (dto: CreateCommentDto): Promise<CommentDto> => {
  try {
    const response = await API.post(`/api/comments`, dto);
    return response.data;
  } catch (error: any) {
    console.error("Failed to add comment:", error);
    throw error.response?.data || new Error("An unexpected error occurred while adding comment.");
  }
};

export const toggleCommentLike = async (commentId: number): Promise<OperationResult<CommentLikeStatus>> => {
  try {
    const response = await API.post(`/api/comments/like/${commentId}`);
    return response.data;
  } catch (error: any) {
    console.error("Failed to toggle comment like:", error);
    throw error.response?.data || new Error("An unexpected error occurred while toggling like.");
  }
};